import { Box, Tooltip, Typography } from '@mui/material';
import type { BankStatementImportPreview } from '../types';
import { formatSourcePeriod, valueOrUnresolved } from './bankStatementImportUiUtils';

const SummaryField = ({ label, value }: { label: string; value?: string | number | null }) => (
  <Tooltip title={valueOrUnresolved(value)} placement="top-start">
    <Box sx={{ minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography
        variant="body2"
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
      >
        {valueOrUnresolved(value)}
      </Typography>
    </Box>
  </Tooltip>
);

export const BankStatementSourceSummary = ({
  preview,
}: {
  preview: BankStatementImportPreview;
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, minmax(0, 1fr))' },
      gap: 1,
    }}
  >
    <SummaryField label="File" value={preview.Statement.FileName} />
    <SummaryField
      label="Source Period"
      value={formatSourcePeriod(
        preview.Statement.SourcePeriodFrom,
        preview.Statement.SourcePeriodTo
      )}
    />
    <SummaryField label="Transactions" value={preview.Transactions.length} />
    <SummaryField label="Detected Company" value={preview.Statement.CompanyName} />
    <SummaryField label="Detected Bank" value={preview.Statement.BankName} />
    <SummaryField
      label="Detected Bank Account"
      value={preview.Statement.BankAccountName ?? preview.Statement.AccountNumber}
    />
    <SummaryField label="Detected Currency" value={preview.Statement.AccountCurrency} />
  </Box>
);
